export default __webpack_public_path__ + "assets/img/5_stars.svg";